import React, { useState, useEffect, ClipboardEvent } from 'react';
import PasswordInput from './password-input';

interface ConfirmPasswordInputProps {
  label: string;
  id: string;
  name: string;
  value: string;
  password: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  placeholder?: string;
  className?: string;
  autoComplete?: string;
  disabled?: boolean;
  forceLightMode?: boolean;
  onValidationChange?: (isValid: boolean) => void;
}

/**
 * Composant de confirmation de mot de passe avec validation en temps réel
 */
const ConfirmPasswordInput: React.FC<ConfirmPasswordInputProps> = ({
  label,
  id,
  name,
  value,
  password,
  onChange,
  required = false,
  placeholder = '',
  className = '',
  autoComplete = 'new-password',
  disabled = false,
  forceLightMode = false,
  onValidationChange
}) => {
  const [isValid, setIsValid] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  // Empêcher le collage dans le champ de confirmation
  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
  };

  // Vérifier si les mots de passe correspondent
  useEffect(() => {
    if (value) {
      setShowMessage(true);
      const passwordsMatch = value === password;
      setIsValid(passwordsMatch);
      
      if (onValidationChange) {
        onValidationChange(passwordsMatch);
      }
    } else {
      setShowMessage(false);
    }
  }, [value, password, onValidationChange]);

  return (
    <div className={className}>
      <PasswordInput
        label={label}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        className={className}
        autoComplete={autoComplete}
        disabled={disabled}
        forceLightMode={forceLightMode}
        onPaste={handlePaste}
      />
      
      {showMessage && (
        <div className="mt-2 text-sm">
          <div className="flex items-center">
            {isValid ? (
              <svg className="h-4 w-4 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg className="h-4 w-4 text-red-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
            <span className={isValid ? `text-green-600 ${!forceLightMode ? 'dark:text-green-400' : ''}` : `text-red-600 ${!forceLightMode ? 'dark:text-red-400' : ''}`}>
              {isValid ? 'Les mots de passe correspondent' : 'Les mots de passe ne correspondent pas'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmPasswordInput;
